// extracted by mini-css-extract-plugin
export var displayNone = "_me-6";
export var imgContainer = "_me-2";
export var overflowHidden = "_me-3";
export var productInfoCardButtonContainer = "_me-5";
export var productTitleText = "_me-4";
export var rightArrow = "_me-1";
export var rightArrowContainer = "_me-0";